@if (showStatement) {
<div class="d-flex justify-content-end mb-2">
  <mat-icon
    matListItemIcon
    class="close-icon"
    (click)="onBackToStatementsClicked()"
    >close</mat-icon
  >
</div>
<embed
  class="pdf-viewer"
  [src]="statementPdfUrl"
  type="application/pdf"
  width="100%"
  height="500"
/>
} @if (!showStatement) {
<mat-card>
  @if (!loading) {
  <mat-card-content>
    <table mat-table matSort [dataSource]="statements">
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Date</th>
        <td mat-cell *matCellDef="let element">
          {{ element?.date }}
        </td>
      </ng-container>

      <ng-container matColumnDef="income">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Income</th>
        <td mat-cell *matCellDef="let element">
          {{ getTotalIncome(element) | currency : "R" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="expenses">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Expenses</th>
        <td mat-cell *matCellDef="let element">
          {{ getTotalExpenses(element) | currency : "R" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="total">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Net Total</th>
        <td mat-cell *matCellDef="let element">
          {{ getTotal(element) | currency : "R" }}
        </td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let element">
          <div class="centered-vertically">
            <mat-icon class="{{ utils.getPaymentStatusColor(element.status) }}">
              {{ utils.getPaymentStatusIcon(element.status) }}
            </mat-icon>
            <span class="small-light-grey">
              {{ this.getStatusText(element) }}
            </span>
          </div>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="statementColumns"></tr>
      <tr
        mat-row
        *matRowDef="let row; columns: statementColumns"
        class="pointer"
        (click)="onViewStatementClicked(row)"
      ></tr>

      <tr *matNoDataRow>
        <td colspan="4">
          <div class="p-3">No statements found.</div>
        </td>
      </tr>
    </table>
  </mat-card-content>
  } @else {
  <div class="my-3 d-flex justify-content-center">
    <mat-progress-spinner diameter="30" mode="indeterminate" color="primary">
    </mat-progress-spinner>
  </div>
  }

  <mat-card-actions>
    <mat-paginator
      (page)="onPageChange($event)"
      [length]="totalStatements"
      [pageSize]="pageSize"
      [pageSizeOptions]="[20, 50, 100]"
      [pageIndex]="pageIndex"
      aria-label="Select page"
    >
    </mat-paginator>
  </mat-card-actions>
</mat-card>
}
